import { makeStyles } from '@mui/styles'

const useStyles = makeStyles(theme => ({
  mainTitle: {
    marginBottom: theme.spacing(1.25),
  },
  subtitle: {
    marginBottom: theme.spacing(2.5),
  },
  paper: {
    marginTop: theme.spacing(4),
    padding: theme.spacing(8, 0),
  },
  mainContainer: {
    maxWidth: 850,
  },
  explanation: {
    maxWidth: 477,
  },
  fieldTextContainer: {
    marginTop: theme.spacing(4.25),
  },
  fieldTextPerson: {
    marginBottom: theme.spacing(1.25),
  },
  fieldTextSecondaryContainer: {
    display: 'flex',
    gap: theme.spacing(2),
  },
  changePasswordContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    columnGap: theme.spacing(2),
    marginTop: theme.spacing(4.25),
  },
  changePasswordActionButtons: {
    display: 'flex',
    marginTop: theme.spacing(4.25),
    columnGap: theme.spacing(2),
  },
  helperText: {
    display: 'flex',
    alignItems: 'center',
    columnGap: theme.spacing(1),
    '& svg': {
      color: theme.palette.turquoise.dark,
    },
  },
  alertSuccess: {
    marginTop: theme.spacing(2),
  },
  alertError: {
    marginTop: theme.spacing(2),
  },
  currentPasswordContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    marginTop: theme.spacing(4.25),
    rowGap: theme.spacing(1),
  },
}))

export default useStyles
